__turbopack_context__.v({
  "animatedTabGroup": "AnimatedTabs-module-scss-module__ms2neG__animatedTabGroup",
  "companyLogo": "AnimatedTabs-module-scss-module__ms2neG__companyLogo",
  "currentTab": "AnimatedTabs-module-scss-module__ms2neG__currentTab",
  "currentTabHighlighter": "AnimatedTabs-module-scss-module__ms2neG__currentTabHighlighter",
  "employmentPeriod": "AnimatedTabs-module-scss-module__ms2neG__employmentPeriod",
  "hidden": "AnimatedTabs-module-scss-module__ms2neG__hidden",
  "jobTitle": "AnimatedTabs-module-scss-module__ms2neG__jobTitle",
  "tab": "AnimatedTabs-module-scss-module__ms2neG__tab",
  "tabList": "AnimatedTabs-module-scss-module__ms2neG__tabList",
  "tabPanels": "AnimatedTabs-module-scss-module__ms2neG__tabPanels",
  "team": "AnimatedTabs-module-scss-module__ms2neG__team",
});
